<script setup lang="ts">
import { computed } from 'vue';

interface ButtonDropdownItem {
  label: string;
  disabled?: boolean;
  value: string | null;
}

const tableSize = defineModel();

const props = defineProps<{
  items: ButtonDropdownItem[];
  tooltip?: string;
  loading?: boolean;
}>();

const dropdownModel = computed(() => {
  return props.items.map((item) => {
    const { disabled, label, value } = item;

    if (item.disabled) {
      return {
        label,
        disabled,
      };
    }

    return {
      label,
      command: () => (tableSize.value = value),
    };
  });
});
</script>

<template>
  <SplitButton
    v-tooltip.top="{ value: tooltip ? $t(tooltip) : '', showDelay: 1000 }"
    menuButtonIcon="pi pi-table"
    pt:button:root="hidden"
    pt:menuButton:root="af-filter-button  h-9 w-9 px-4 py-1.5"
    pt:menu:menuItem="text-sm"
    :disabled="loading"
    :model="dropdownModel"
  />
</template>
